import React, { ReactNode } from 'react'

import Box from 'components_new/atoms/Box'

export interface DataHealthKpiGridProps {
  children: ReactNode
}

/**
 * The four-up KPI grid every Datahälsa tab opens with. Collapses to two
 * columns on narrow viewports rather than reflowing to one - this is an
 * internal desktop tool, and two columns still read as a row.
 */
const DataHealthKpiGrid = (props: DataHealthKpiGridProps) => {
  return (
    <Box
      sx={{
        display: 'grid',
        gap: '14px',
        gridTemplateColumns: { xs: 'repeat(2, 1fr)', md: 'repeat(4, 1fr)' }
      }}
    >
      {props.children}
    </Box>
  )
}

DataHealthKpiGrid.displayName = 'DataHealthKpiGrid'
export default DataHealthKpiGrid
